import apiService from "./BaseApi";

const BASE_DOCUMENTS_URL = 'documents'

const DocumentsService = {
    createDocument: async (idEnvelope, document) => apiService.post(`${BASE_DOCUMENTS_URL}/${idEnvelope}`, document),
    getAllDocuments: async (idEnvelope) => apiService.get(`${BASE_DOCUMENTS_URL}/${idEnvelope}`),
    deleteDocument: async (idEnvelope, idDocument) => apiService.delete(`${BASE_DOCUMENTS_URL}/${idEnvelope}/${idDocument}`),
    cancelDocument: async (idEnvelope, idDocument) => apiService.patch(`${BASE_DOCUMENTS_URL}/${idEnvelope}/${idDocument}`),
}

export default DocumentsService;